import React from "react";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import Input from "../Formsy/Input";
import Wysiwyg from "../Formsy/Wysiwyg";
import InspectorSection from "./InspectorSection";
import theme from "../../themes/green";
import { FileInput } from "../Formsy";
import { Button } from "../../components/UIKit";
import TrashIcon from "react-icons/lib/fa/trash-o";
import PaddingController from "../PaddingController";
import { SketchPicker } from "react-color";

class InfoWindowWidgetEditor extends React.Component {
  constructor(props) {
    super();
    this.state = {
      canSubmit: false
    };

    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onPrefabButtonClick = this.onPrefabButtonClick.bind(this);
    this.createPrefab = this.createPrefab.bind(this);
  }

  onReset(fields) {
    const model = this.form.getModel();
    this.form.reset({ ...model, ...fields });
  }

  switchAutoSubmit(canSubmit) {
    this.setState({ canSubmit });
  }

  autoSubmit() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.timeoutId = setTimeout(() => {
      if (this.form && this.state.canSubmit) {
        this.form.submit();
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      } else {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    }, 1000);
  }

  onPrefabButtonClick() {
    if (this.props.element.prefab) {
      this.deletePrefab();
    } else if (this.props.element.prefabId) {
      this.breakPrefab();
    } else {
      this.createPrefab();
    }
  }

  createPrefab() {
    const {
      name,
      type,
      icon_image = {},
      icon_width,
      window_image = {},
      window_width,
      window_height,
      window_corners,
      window_padding,
      window_positionX,
      window_positionY,
      button_image = {},
      button_width,
      button_positionX,
      button_positionY,
      body
    } = this.props.element;
    if (this.props.onPrefabCreate) {
      this.props.onPrefabCreate({
        name,
        type,
        icon_image,
        icon_width,
        window_image,
        window_width,
        window_height,
        window_corners,
        window_padding,
        window_positionX,
        window_positionY,
        button_image,
        button_width,
        button_positionX,
        button_positionY,
        body,
        prefab: true
      });
    }
  }

  breakPrefab() {
    if (this.props.onPrefabBreak) {
      this.props.onPrefabBreak();
    }
  }

  deletePrefab() {
    if (this.props.onPrefabDelete) {
      this.props.onPrefabDelete(this.props.element.id);
    }
  }

  onValidSubmit(data) {
    var path;
    const { projectId } = this.props.match.params;
    const preparedData = Object.assign({}, data);
    preparedData.title = data.title || "";
    preparedData.body = data.body || "";
    if (this.props.element.prefab) {
      path = this.props.path;
      this.props.onValidSubmit(preparedData, path);
      //this.updateWidgetsOfPrefab(this.props.element.id, data);
    } else if (this.props.element.prefabId) {
      path = `/projects/${projectId}/prefabs/${this.props.element.prefabId}`;
      this.props.onValidSubmit(preparedData, path);
      //this.updateWidgetsOfPrefab(this.props.element.prefabId, data);
    } else {
      path = this.props.path;
      this.props.onValidSubmit(preparedData, path);
    }
  }

  updateWidgetsOfPrefab(prefabId, preparedData) {
    var path;
    const { projectId } = this.props.match.params;
    for (var sceneId in this.props.projects[projectId].scenes) {
      for (var layerId in this.props.projects[projectId].scenes[sceneId]
        .layers) {
        for (var widgetId in this.props.projects[projectId].scenes[sceneId]
          .layers[layerId].widgets) {
          if (
            this.props.projects[projectId].scenes[sceneId].layers[layerId]
              .widgets[widgetId].prefabId === prefabId
          ) {
            path = `projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets/${widgetId}`;
            this.props.onValidSubmit(preparedData, path);
          }
        }
      }
    }
  }

  render() {
    const { project } = this.props;
    const { projectId } = this.props.match.params;
    const projectColors = [project.color || '#000000'];
    // todo: add extra colors defined by user

    const {
      prefab_label = this.props.element.prefabId
        ? "Przerwij prefab"
        : this.props.element.prefab
          ? "Usuń prefab"
          : "Utwórz prefab",
      name,
      icon_image: { downloadURL: iconDownloadURL = "" } = {},
      icon_width = "100px",
      window_image: { downloadURL: windowDownloadURL = "" } = {},
      window_width = "400px",
      window_height = "200px",
      window_corners = "0",
      window_positionX = "0",
      window_positionY = "0",
      window_padding = { top: 0, right: 0, bottom: 0, left: 0 },
      button_image: { downloadURL: buttonDownloadURL = "" } = {},
      button_width = "100",
      button_positionX = "0",
      button_positionY = "0"
    } = this.props.element.prefabId
      ? this.props.project.prefabs[this.props.element.prefabId]
      : this.props.element;
    return (
      <Formsy
        onValid={() => {
          this.switchAutoSubmit(true);
        }}
        onInvalid={() => {
          this.switchAutoSubmit(false);
        }}
        onValidSubmit={this.onValidSubmit}
        onChange={() => {
          this.autoSubmit();
        }}
        style={{ width: "100%" }}
        ref={component => {
          this.form = component;
        }}
      >
        <Button
          type="button"
          style={{
            background: "rgb(45,228,136)",
            marginLeft: "0px"
          }}
          onClick={this.onPrefabButtonClick}
        >
          <span style={{ color: "rgb(72,97,102)" }}>{prefab_label}</span>
        </Button>
        <InspectorSection hideHeader>
          <Input
            name="name"
            placeholder="Widget name..."
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: "0" }
            }}
            /* forceBackground */
            value={this.props.element.name}
          />
        </InspectorSection>
        <InspectorSection onReset={this.onReset} title={"ICON"}>
          <FileInput
            name="icon_image"
            style={{ color: "black" }}
            imageUrl={iconDownloadURL}
            multiple={false}
            value={{ downloadURL: iconDownloadURL }}
          />
          <Input
            name="icon_width"
            placeholder="Icon width"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={icon_width}
          />
        </InspectorSection>
        <InspectorSection onReset={this.onReset} title={"WINDOW"}>
          <FileInput
            name="window_image"
            style={{ color: "black" }}
            imageUrl={windowDownloadURL}
            multiple={false}
            value={{ downloadURL: windowDownloadURL }}
          />
          <Input
            name="window_width"
            placeholder="Window width"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={window_width}
          />
          <Input
            name="window_height"
            placeholder="Window height"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={window_height}
          />
          <Input
            name="window_corners"
            placeholder="Window corners"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={window_corners}
          />
          <PaddingController
            title="Padding"
            name="window_padding"
            value={window_padding}
          />

          <Input
            name="window_positionX"
            placeholder="Window position X"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={window_positionX}
          />
          <Input
            name="window_positionY"
            placeholder="Window position Y"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={window_positionY}
          />
        </InspectorSection>
        <InspectorSection onReset={this.onReset} title={"BUTTON"}>
          <FileInput
            name="button_image"
            style={{ color: "black" }}
            imageUrl={buttonDownloadURL}
            multiple={false}
            value={{ downloadURL: buttonDownloadURL }}
          />
          <Input
            name="button_width"
            placeholder="Button width"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={button_width}
          />
          <Input
            name="button_positionX"
            placeholder="Button position X"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={button_positionX}
          />
          <Input
            name="button_positionY"
            placeholder="Button position Y"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={button_positionY}
          />
        </InspectorSection>
        <InspectorSection title="CONTENTS" onReset={this.onReset}>
          <Input
            name="title"
            placeholder="Window title"
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: "10px 0" }
            }}
            value={this.props.element.title}
          />
          <Wysiwyg textColors={projectColors} name="body" value={this.props.element.body} />
        </InspectorSection>
      </Formsy>
    );
  }
}

InfoWindowWidgetEditor.propTypes = {
  path: PropTypes.string.isRequired,
  element: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  onValidSubmit: PropTypes.func
};

InfoWindowWidgetEditor.defaultProps = {
  onValidSubmit: () => {}
};

export default InfoWindowWidgetEditor;



// WEBPACK FOOTER //
// ./src/components/Inspector/infoWindowWidgetEditor.js